export const ProductDesktopIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect width='32' height='32' rx='4' fill='#F5F5F5' />
    <g clipPath='url(#clip0_1451_2140)'>
      <path
        d='M24 8H8C6.89543 8 6 8.89543 6 10V22C6 23.1046 6.89543 24 8 24H24C25.1046 24 26 23.1046 26 22V10C26 8.89543 25.1046 8 24 8Z'
        fill='#0F172A'
      />
      <path
        d='M6 12H26'
        stroke='white'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 20H22'
        stroke='white'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_1451_2140'>
        <rect width='20' height='20' fill='white' transform='translate(6 6)' />
      </clipPath>
    </defs>
  </svg>
)
